module.exports = [
  {
    "geo": "Birmingham-Hoover, AL",
    "abs8020": 7.3,
    "p20": 71.8,
    "p80": 79.1,
    "LE": 75.36
  },
  {
    "geo": "Memphis, TN-MS-AR",
    "abs8020": 7.3,
    "p20": 72.2,
    "p80": 79.5,
    "LE": 75.84
  },
  {
    "geo": "Los Angeles-Long Beach-Anaheim, CA",
    "abs8020": 5.2,
    "p20": 78.2,
    "p80": 83.4,
    "LE": 80.86
  },
  {
    "geo": "San Diego-Carlsbad, CA",
    "abs8020": 4.5,
    "p20": 78.6,
    "p80": 83.1,
    "LE": 80.88
  },
  {
    "geo": "San Francisco-Oakland-Hayward, CA",
    "abs8020": 5.5,
    "p20": 78.9,
    "p80": 84.4,
    "LE": 81.55
  },
  {
    "geo": "San Jose-Sunnyvale-Santa Clara, CA",
    "abs8020": 4.1,
    "p20": 80.7,
    "p80": 84.8,
    "LE": 82.71
  },
  {
    "geo": "Denver-Aurora-Lakewood, CO",
    "abs8020": 5.1,
    "p20": 77,
    "p80": 82.1,
    "LE": 79.52
  },
  {
    "geo": "Hartford-West Hartford-East Hartford, CT",
    "abs8020": 4.4,
    "p20": 77.9,
    "p80": 82.3,
    "LE": 80.09
  },
  {
    "geo": "Philadelphia-Camden-Wilmington, PA-NJ-DE-MD",
    "abs8020": 6.5,
    "p20": 75,
    "p80": 81.5,
    "LE": 78.19
  },
  {
    "geo": "Jacksonville, FL",
    "abs8020": 5.9,
    "p20": 74.4,
    "p80": 80.3,
    "LE": 77.23
  },
  {
    "geo": "Orlando-Kissimmee-Sanford, FL",
    "abs8020": 5.1,
    "p20": 76.6,
    "p80": 81.7,
    "LE": 79.33
  },
  {
    "geo": "Tampa-St. Petersburg-Clearwater, FL",
    "abs8020": 5.6,
    "p20": 74.9,
    "p80": 80.5,
    "LE": 77.7
  },
  {
    "geo": "Atlanta-Sandy Springs-Roswell, GA",
    "abs8020": 5.3,
    "p20": 75.3,
    "p80": 80.6,
    "LE": 78.01
  },
  {
    "geo": "Chicago-Naperville-Elgin, IL-IN-WI",
    "abs8020": 5.8,
    "p20": 76.1,
    "p80": 81.9,
    "LE": 78.97
  },
  {
    "geo": "St. Louis, MO-IL",
    "abs8020": 6.4,
    "p20": 74.7,
    "p80": 81.1,
    "LE": 77.81
  },
  {
    "geo": "Cincinnati, OH-KY-IN",
    "abs8020": 6.7,
    "p20": 74,
    "p80": 80.7,
    "LE": 77.41
  },
  {
    "geo": "Indianapolis-Carmel-Anderson, IN",
    "abs8020": 6.6,
    "p20": 74.1,
    "p80": 80.7,
    "LE": 77.4
  },
  {
    "geo": "Louisville/Jefferson County, KY-IN",
    "abs8020": 6.7,
    "p20": 73.4,
    "p80": 80.1,
    "LE": 76.7
  },
  {
    "geo": "Kansas City, MO-KS",
    "abs8020": 5.8,
    "p20": 75.3,
    "p80": 81.1,
    "LE": 78.2
  },
  {
    "geo": "New Orleans-Metairie, LA",
    "abs8020": 6.6,
    "p20": 73.2,
    "p80": 79.8,
    "LE": 76.55
  },
  {
    "geo": "Baltimore-Columbia-Towson, MD",
    "abs8020": 6.5,
    "p20": 74.5,
    "p80": 81,
    "LE": 77.85
  },
  {
    "geo": "Boston-Cambridge-Newton, MA-NH",
    "abs8020": 4.6,
    "p20": 78.6,
    "p80": 83.2,
    "LE": 80.99
  },
  {
    "geo": "Providence-Warwick, RI-MA",
    "abs8020": 4.6,
    "p20": 76.8,
    "p80": 81.4,
    "LE": 79.17
  },
  {
    "geo": "Detroit-Warren-Dearborn, MI",
    "abs8020": 7.3,
    "p20": 73.4,
    "p80": 80.7,
    "LE": 77.14
  },
  {
    "geo": "Grand Rapids-Wyoming, MI",
    "abs8020": 4.9,
    "p20": 77.6,
    "p80": 82.5,
    "LE": 80.17
  },
  {
    "geo": "Minneapolis-St. Paul-Bloomington, MN-WI",
    "abs8020": 5.2,
    "p20": 78.4,
    "p80": 83.6,
    "LE": 80.68
  },
  {
    "geo": "Las Vegas-Henderson-Paradise, NV",
    "abs8020": 4.7,
    "p20": 75.3,
    "p80": 80,
    "LE": 77.57
  },
  {
    "geo": "Buffalo-Cheektowaga-Niagara Falls, NY",
    "abs8020": 5.4,
    "p20": 75.8,
    "p80": 81.2,
    "LE": 78.3
  },
  {
    "geo": "Rochester, NY",
    "abs8020": 5.8,
    "p20": 77.5,
    "p80": 83.3,
    "LE": 80.32
  },
  {
    "geo": "Charlotte-Concord-Gastonia, NC-SC",
    "abs8020": 6.2,
    "p20": 74.5,
    "p80": 80.7,
    "LE": 77.68
  },
  {
    "geo": "Raleigh, NC",
    "abs8020": 4.7,
    "p20": 77.2,
    "p80": 81.9,
    "LE": 79.68
  },
  {
    "geo": "Virginia Beach-Norfolk-Newport News, VA-NC",
    "abs8020": 6,
    "p20": 74.4,
    "p80": 80.4,
    "LE": 77.46
  },
  {
    "geo": "Columbus, OH",
    "abs8020": 6.5,
    "p20": 74.4,
    "p80": 80.9,
    "LE": 77.66
  },
  {
    "geo": "Oklahoma City, OK",
    "abs8020": 6.9,
    "p20": 73.1,
    "p80": 80,
    "LE": 76.47
  },
  {
    "geo": "Portland-Vancouver-Hillsboro, OR-WA",
    "abs8020": 4.5,
    "p20": 77.3,
    "p80": 81.8,
    "LE": 79.77
  },
  {
    "geo": "Pittsburgh, PA",
    "abs8020": 5.4,
    "p20": 75.6,
    "p80": 81,
    "LE": 78.14
  },
  {
    "geo": "Nashville-Davidson--Murfreesboro--Franklin, TN",
    "abs8020": 6,
    "p20": 74.4,
    "p80": 80.4,
    "LE": 77.26
  },
  {
    "geo": "Houston-The Woodlands-Sugar Land, TX",
    "abs8020": 5.3,
    "p20": 75.8,
    "p80": 81.1,
    "LE": 78.5
  },
  {
    "geo": "San Antonio-New Braunfels, TX",
    "abs8020": 5.4,
    "p20": 75.6,
    "p80": 81,
    "LE": 78.34
  },
  {
    "geo": "Salt Lake City, UT",
    "abs8020": 4.4,
    "p20": 76.8,
    "p80": 81.2,
    "LE": 78.96
  },
  {
    "geo": "Richmond, VA",
    "abs8020": 5.2,
    "p20": 75.3,
    "p80": 80.5,
    "LE": 77.95
  },
  {
    "geo": "Seattle-Tacoma-Bellevue, WA",
    "abs8020": 5.1,
    "p20": 77.8,
    "p80": 82.9,
    "LE": 80.32
  }
]
